import { Component, ViewChild, OnInit, ElementRef, NgZone } from '@angular/core';
import * as $ from 'jquery';
import { LocalStorageService } from 'angular-2-local-storage';
import { Router } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { Constant } from '../../constant'
import { GlobalService } from '../services/global.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Http } from '@angular/http';
import { map, retry } from 'rxjs/operators';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-display-data',
  templateUrl: './display-data.component.html',
  styleUrls: ['./display-data.component.css']
})
export class DisplayDataComponent implements OnInit {
  @ViewChild('autoclickone') autoclickone: ElementRef;
  @ViewChild('autoclicktwo') autoclicktwo: ElementRef;
  @ViewChild('templet2') templet2: ElementRef;
  public isstatus;
  public originalPremiumAmont;
  public userdata: any;
  public preferedDateList = [];
  isallowed = 'Y';
  modalRef: BsModalRef;
  modalRef1: BsModalRef;
  emandate: any;
  public mandateVal;
  ccsi: any;
  enach: any;
  ccsiReturnUrl: any;
  upiManUrl: any;
  showEnach: boolean = true;
  paymentType: any;
  isLimitCross = false;
  showCCSIPan = false;
  showUPIPan = false;
  showEnachPan = false;
  showEmandatePan = false;
  frequency: any;
  duedate: any;
  errorMessage: any;
  isthroughCustPortal: boolean = false;
  showPrefillOption:boolean = false;
  // public userDateDetails = {
  //   "dateType": "",
  //   "isDisabled": "",
  //   "selectedPDate": ""
  // }
  // for register account no
  public userDateDetails = {
    "dateType": "",
    "isDisabled": "",
    "selectedPDate": "",
    "registerAccount":"N"
  }
  getAccountNo;
  getIFSCNo;
  r_registerType:any = '';
  public isShow: boolean = false;
  downTimeData:any = [];
  desableForDwontime:boolean = false;
  isChannel:any;
  isApplnChannel:any;
  encryptValue:any;
  enableForVendor:any;
  agentCode:any
  activateUPIForNB:any;
  moduleFlag:boolean = false;
  mandateValueForUpi:any;
  activateUPI:boolean = false;
  calculateFreq:any;
  getpsfFlag:any; 
    //activate international ccsi start 
    ccsiPayglocal: any;
    datePipe: DatePipe = new DatePipe('en-US');
    showCCSINRI = false;
    //activate international ccsi end
  
    //payglocal integartion
    enableForCCSIVendor :any;
    enableForUPIVendor :any;
    
   // mandateAmountNewCustomer :any;
  constructor(private localStorageService: LocalStorageService,
    private router: Router, private modalService: BsModalService,
    private toster: ToastrService,private http:Http,private service: GlobalService,private spinner: NgxSpinnerService,private ngZone: NgZone) { }

  ngOnInit() {
  // debugger;
  this.checkWarningMsg();
 
    this.frequency = "";
    this.duedate = "";
    this.loadJs();
    this.showEnach = true;
    this.paymentType = this.localStorageService.get('customerportal');
    this.isChannel = this.localStorageService.get('channel');
    this.isApplnChannel = this.localStorageService.get('applnChannel');
    this.isstatus = this.localStorageService.get('Status');
    this.userdata = this.localStorageService.get('userdata');
    this.agentCode = this.localStorageService.get('agentCode');
    this.getpsfFlag = this.localStorageService.get('setPSFFlag');

    this.checkForVendor();
    this.checkForUPIVendor();
    this.checkForCCSIVendor();
  
    if(this.localStorageService.get('moduleFlag')){
      if(this.localStorageService.get('moduleFlag') == "IPPBBC" || this.localStorageService.get('moduleFlag') == "IPPB" || this.localStorageService.get('moduleFlag') == "IPPBC"){
        this.moduleFlag = true;
      }
    }
    
    this.maskifyACno();
    if(this.isstatus === 'newCustomer'){
    if(this.userdata.stringval8 && this.userdata.stringval9 || this.userdata.stringval8 != '' && this.userdata.stringval9 !='' ) {
      this.showPrefillOption = true;
    }


    if (this.localStorageService.get('FLAG')) {
      if (this.localStorageService.get('FLAG') == "NRI" || this.localStorageService.get('FLAG') == "FOREIGN NATIONAL") {
        this.showCCSINRI = true;
      }
    }
    // for encrypt the mandate value;
    // if(this.userdata && this.userdata.stringval5){
    //   let url = Constant.BaseUrl + Constant.getEncryptData;
    //   let reqObj = {
    //     "encrypt_decrypt_req_resp":this.userdata.stringval5,
	  //     "flag":"encrypt"
    //   }
    //   this.service.PostService(url, reqObj).subscribe(response => {
    //     if(response){
    //       this.encryptValue = response.encrypt_decrypt_req_resp
    //     }
    //   })
    // }
  }
  
  
  if (this.isstatus === 'existingCustomer') {
    if (this.localStorageService.get('FLAGFOREXISTING') == "NRI" || this.localStorageService.get('FLAGFOREXISTING') == "FOREIGN NATIONAL") {
      this.showCCSINRI = true;
    }
  }

    this.originalPremiumAmont = this.localStorageService.get('originalpremiumamt');
    this.mandateVal = this.localStorageService.get('mandateVal');
    if (this.paymentType !== null && this.paymentType !== 'null' && this.paymentType !== "" && this.paymentType !== 'undefined') {
     
        var acc = document.getElementById('autoclickthree').click();
        $('#panthree').css('max-height', '1500px');
      if (this.paymentType.toLowerCase() == 'all') {
        this.showEnachPan = true;
        this.showEmandatePan = true;
        //this.showUPIPan = true;
      } else if (this.paymentType.toLowerCase() == 'ccsi') {
        // this.toster.error("CCSI facility is not available. Request to you please select another renewal preferred mode.");
        //return;
      } else if (this.paymentType.toLowerCase() == 'nach' || this.paymentType.toLowerCase() == 'enach') {
        this.showEnachPan = true;
        var acc = document.getElementById('autoclickone').click();
        $('#panone').css('max-height', '1500px');
      } else if (this.paymentType.toLowerCase() == 'mandate' || this.paymentType.toLowerCase() == 'emand') {
        this.showEmandatePan = true;
        var acc = document.getElementById('autoclickone').click();
        $('#panone').css('max-height', '1500px');
      }
       else if (this.paymentType.toLowerCase() == 'upi') {
        this.showUPIPan = true;
        var acc = document.getElementById('autoclicktwo').click();
        $('#pantow').css('max-height', '1500px');
      }
      else {
        alert("You have opted wrong module. you can't proceed further");
      }
    } else {
      // this.showCCSIPan = true;
    //  this.showUPIPan = true;
      this.showEnachPan = true;
      this.showEmandatePan = true;
    }
    this.emandate = Constant.BaseUrl + Constant.emandate;
    this.ccsi = Constant.ccsi;
    this.enach = Constant.BaseUrl + Constant.enach;
    this.ccsiReturnUrl = Constant.BaseUrl + Constant.return_url_ccsi;
    this.upiManUrl = Constant.BaseUrl + Constant.upiMandate;
    this.userDateDetails.dateType = "SAME";
    this.userDateDetails.isDisabled = "false";
    if (this.isstatus === 'newCustomer') {
    
      //calculate mandate value for UPI (upi dosen't have 125% premium functionality that's why calculated seprate premium)
   
      // if(this.localStorageService.get('moduleFlag') == 'GBOWEB'){
      //   this.mandateValueForUpi = (this.originalPremiumAmont * 1.25).toFixed(2) //call no : MRKT-2104
      // }else{
      //   this.mandateValueForUpi = (this.originalPremiumAmont * 1.10).toFixed(2)
      // }

      // if( this.isApplnChannel == 'psf_defence' || this.isApplnChannel == 'PSF_DEFENCE'){
      //   this.mandateAmountNewCustomer = this.userdata.stringval5;
      // }else{
      // this.mandateAmountNewCustomer = (this.originalPremiumAmont * 1.50).toFixed(2) //ops-19382
      // }

     if (this.userdata.stringval5 > 10000000) {
      this.showEnach = false;
    } else {
      this.showEnach = true;
    }

      this.activateUPI = false;
      this.showUPIPan = false;
      // upi enable for instab
    // if(this.isChannel == 'agency' && this.userdata.stringval5 < 15000){
    //    this.showUPIPan = true;
    // }
    // upi enabled for new cust
    if(this.userdata.stringval5 < 15000){
      //if(this.isApplnChannel == 'agency' || this.isApplnChannel == 'psf'){
        if(this.isApplnChannel == 'psf'){
        this.showUPIPan = true;
        this.activateUPIForNB = true;
      }
    }
    if(this.agentCode == '3000000007' && this.userdata.stringval5 < 15000){
       this.showUPIPan = true;
       this.activateUPIForNB = true;
    }
    if(this.localStorageService.get('moduleFlag') == 'GBOWEB' && this.userdata.stringval5 < 100000){
      this.showUPIPan = true;
      this.activateUPIForNB = true;
    }

    let url = Constant.validateUPIAgent;
    let reqObj =
      {
        agentCode: this.agentCode,
        sysType: "UPI_CONFIG"
      }
      this.service.PostService(url, reqObj).subscribe(response => {
      if (response.isAuthenticated === 'Y' && this.userdata.stringval5 < 15000) {
          this.showUPIPan = true;
          this.activateUPIForNB = true;
      }
      })

     // ccsi enabled for 15k on 22-11-23
     
     if (this.userdata.stringval5 > 15000) {
      this.showCCSIPan = false;
    } else {
      this.showCCSIPan = true;
    }
  
      /*--validation for 5k amount for UPI Mandate added on 26-05-2021--*/
      // if (this.originalPremiumAmont > 15000) {
      //   this.showUPIPan = false;
      // } else {
      //   this.showUPIPan = true;
      // }
      /*--validation for 5k amount for UPI Mandate added on 27-07-2021 by trupti--*/
      // if (this.mandateVal > 15000) {
      //   this.showUPIPan = false;
      // } else {
      //   this.showUPIPan = true;
      // }
    } else if (this.isstatus === 'existingCustomer') {
      this.frequency = this.userdata[0].stringval20;
      this.duedate = this.userdata[0].stringval3;
     /// this.mandateVal = this.userdata[0].stringval31; //OPS-19382
      //calculations for PSF_DEFENCE policies.
      if(this.userdata[0].stringval20 == 'Annual' || this.userdata[0].stringval20 == 'Yearly' || this.userdata[0].stringval20 == 'ANNUAL' || this.userdata[0].stringval20 == 'annual'){
        this.calculateFreq = 1;
      }else if(this.userdata[0].stringval20 == 'Half-Yearly' || this.userdata[0].stringval20 == 'SEMI_ANNUAL' || this.userdata[0].stringval20 == 'Semi-Annual'){
        this.calculateFreq = 2;
      }else if(this.userdata[0].stringval20 == 'Quarterly' || this.userdata[0].stringval20 == 'QUARTERLY' || this.userdata[0].stringval20 == 'Quartearly' || this.userdata[0].stringval20 == 'QUARTEARLY'){ 
        this.calculateFreq = 4; 
      }else if(this.userdata[0].stringval20 == 'Monthly' || this.userdata[0].stringval20 ==  'MONTHLY'){
        this.calculateFreq = 12; 
      }
      this.mandateVal = this.userdata[0].stringval12 * 1.50;
      
      // if(this.getpsfFlag == 'PSF_DEFENCE'){
      //   this.userdata[0].stringval31 = this.userdata[0].stringval31 * this.calculateFreq;
      // }
      if(this.getpsfFlag == 'PSF_DEFENCE'){
        this.userdata[0].stringval31 = (this.userdata[0].stringval12 * 1.50) * this.calculateFreq;
      }else{
        this.userdata[0].stringval31 = this.userdata[0].stringval12 * 1.50;
      }


      let [day,month,year] = this.userdata[0].stringval32.split(/[-\/]/);
        let [day2,month2,year2] = this.userdata[0].stringval33.split(/[-\/]/);
 
        if(day === '29' && month === '02'){
          day = '28';
          this.userdata[0].stringval32 = `${day}-${month}-${year}`
        }
        if(day2 === '29' && month2 === '02'){
          day2 = '28';
          this.userdata[0].stringval33 = `${day2}-${month2}-${year2}`
        }

      if (this.mandateVal > 10000000) {
        this.showEnach = false;
        if(this.paymentType){
          if (this.paymentType.toLowerCase() == 'nach' || this.paymentType.toLowerCase() == 'enach') {
            this.showEnachPan = false;
            alert("Mandate amount exceeds maximum amount limit, please select another Autopayment mode to proceed.")
          }
        }  
      } else {
          this.showEnach = true;
      }

       //OPS-11883
      if (this.mandateVal < 15000) {
         this.showUPIPan = true;
      } else if (this.mandateVal < 100000 && this.localStorageService.get('setGBOFlag') == 'GBOWEB'){
        this.showUPIPan = true;
      }else {
        this.showUPIPan = false;
      }

       //OPS-11883
      
      


      //ccsi enabled for 15k on 22-11-23
      //enable ccsi for all transactions 13-03-24
      this.showCCSIPan = true;
      // if (this.mandateVal > 15000) {
      //   this.showCCSIPan = false;
      // } else {
      //  this.showCCSIPan = true;
      // }

      if (this.localStorageService.get('FLAGFOREXISTING') == "NRI" || this.localStorageService.get('FLAGFOREXISTING') == "FOREIGN NATIONAL") {
        this.showCCSINRI = true;
      }

       //OPS-16142 blocking for Agency SISO product starts
       let url1 = Constant.validateSISOExtisting;
       let reqObj1 =
       {
         policyNo: this.userdata[0].stringval1
       }
       this.service.PostService(url1, reqObj1).subscribe(response => {
         if (response.policyChanel === 'AGENCY') {
           this.showUPIPan = false;
         }
       })
       //OPS-16142 blocking for Agency SISO product ends


      this.getValue(0);
    }
    if (this.isstatus && this.userdata) {
    } else {
      this.router.navigate(['/dashboard']);
    }

  }


  checkWarningMsg(){
    let url = Constant.downTimeUrl;
    this.http.get(url).pipe(map((res: any) => res.json())).subscribe(res=>{
      if(res){
        
        this.downTimeData = res;
        // this.modalRef1 = this.modalService.show(this.templet2, { class: 'modal-md addcompmodal' });
        this.downTimeData.forEach(element => {
          if (element.downtime_TYPE.toLowerCase() == 'alert') {
            this.desableForDwontime = true;
          }else if(element.downtime_TYPE.toLowerCase() == 'warning'){
          }
        });
      } 
    })
  }


  checkForVendor(){
    //RAZORPAY,
    //TECHPROCESS, basis on that values it will enable and desabled 
   // this.enableForVendor = "TECHPROCESS";
    let url = Constant.vendorTypeNACH
    this.http.get(url).pipe(map((res: any) => res.json())).subscribe(res=>{
      if(res){

        if(this.isstatus=="newCustomer" &&  this.userdata.stringval1.length <  10 ){
          this.enableForVendor = "TECHPROCESS";
        }else{
         this.enableForVendor =  res[0].char_VALUE;
        }
        // this.enableForVendor = "TECHPROCESS";
        // this.enableForVendor = "RAZORPAY";
      }
    })
  }
  
  checkForUPIVendor(){
    //RAZORPAY,
    //TECHPROCESS, 
   // this.enableForUPIVendor = "RAZORPAY";
    let url = Constant.vendorTypeUPI
    this.http.get(url).pipe(map((res: any) => res.json())).subscribe(res=>{
      if(res){
        if(this.isstatus=="newCustomer" &&  this.userdata.stringval1.length <  10 ){
          this.enableForUPIVendor = "TECHPROCESS";
        }else{
        this.enableForUPIVendor  = res[0].char_VALUE;
        }
         //this.enableForUPIVendor = "TECHPROCESS";
        // this.enableForUPIVendor = "RAZORPAY";
      }
    })
  }

  checkForCCSIVendor(){
    //RAZORPAY,
    //TECHPROCESS, 
   // this.enableForUPIVendor = "RAZORPAY";
    let url = Constant.vendorTypeCCSI
    this.http.get(url).pipe(map((res: any) => res.json())).subscribe(res=>{
      if(res){
       
        if(this.isstatus=="newCustomer" &&  this.userdata.stringval1.length <  10 ){
          this.enableForCCSIVendor = "HDFCCCSI";
        }else{
          this.enableForCCSIVendor  = res[0].char_VALUE;
        }
         //this.enableForUPIVendor = "TECHPROCESS";
        // this.enableForUPIVendor = "RAZORPAY";
      }
    })
  }



  convertintoInt(value : any) {
    if (value) {
      return parseInt(value);
    } else {
      return 0;
    }
  }
  getDropdownValue() {
  }
  getValue(no: any) {
    let i = 1, j = 0;
    this.preferedDateList = [];
    this.userDateDetails.selectedPDate = "";
    let day = this.duedate.split("/")[0];
    // console.log("this.duedate is",this.duedate)
    if (day) {
      if (this.frequency == 'Monthly' || this.frequency == '12') {
        j = parseInt(day) + 10;
        if (j > 28) {
          j = 28;
        }
        for (i = 1; i <= j; i++) {
          let temp = { month: i };
          this.preferedDateList.push(temp);
        }
      }
      else if (((this.frequency == 'Quarterly' || this.frequency == '3') || (this.frequency == 'Quartearly' || this.frequency == '3') || (this.frequency == 'Half-Yearly' || this.frequency == '2') || (this.frequency == 'Yearly' || this.frequency == '1')) && (no == '0')) {
        j = 28;
        for (i = 1; i <= j; i++) {
          let temp = { month: i };
          this.preferedDateList.push(temp);
        }
      }
      else if (((this.frequency == 'Quarterly' || this.frequency == '3') || (this.frequency == 'Quartearly' || this.frequency == '3') || (this.frequency == 'Half-Yearly' || this.frequency == '2') || (this.frequency == 'Yearly' || this.frequency == '1')) && (no == '1')) {
        if ((day >= '11') && (day <= '31')) {
          j = parseInt(day) - 10;
          for (i = 1; i <= j; i++) {
            let temp = { month: i };
            this.preferedDateList.push(temp);
          }
        } else {
          this.userDateDetails.selectedPDate = "";
        }
      }

    }
  }
  loadJs() {
    var acc = document.getElementsByClassName("accordion");
    var i;
    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function () {
       //this.classList.toggle("active");
        // var panel = this.nextElementSibling;
        // if (panel.style.maxHeight) {
        //   panel.style.maxHeight = null;
        // } else {
        //   panel.style.maxHeight = panel.scrollHeight + "px";
        // }
      });
    }
  }

  // for maskify AC no
  maskifyACno(){
    if(this.isstatus === 'newCustomer'){
  this.getAccountNo = '';
  this.getIFSCNo = this.userdata.stringval9;
   let accountNo = this.userdata.stringval8;
   if(this.getIFSCNo && accountNo){
     for(let i = 0; i < accountNo.length; i++){
       if(i <=1 || i>accountNo.length-3){
         this.getAccountNo += accountNo[i];
       }else{
         this.getAccountNo += "X";
       }
     }
   }
 }

  }

  payWithRozarPay(){
    let data;
    let merchantID = Constant.RAZORPY_KEY;
    if(this.isstatus === 'newCustomer'){      
      data =   {
        'policyHolderName' :'',
        'totalAmount':0,
         'merchantId':merchantID,
        'consumerId':this.userdata.stringval1,
        'consumerMobileNo':'',
        'consumerEmailId':'',
        'debitStartDate':this.userdata.stringval3,
        'debitEndDate':this.userdata.stringval4,
        'maxAmount':parseFloat(this.userdata.stringval5).toFixed(),
        'amountType':'M',
        'frequency': 'ADHO',
        'moduleName': "INSTAB|OPEN_LINK_NEW",
        'renewalID': "OPEN_LINK_NEW",
        'payableAmount': 0,
        'takeAccountNo': this.userdata.stringval8,
        'takeIFSCCode':this.userdata.stringval9,
        'prefDate': '',
        'prefType':'',
        'authType': this.r_registerType,
       }
    }else if(this.isstatus === 'existingCustomer'){
      data =   {
        'policyHolderName' :'',
        'totalAmount':5,
         'merchantId':merchantID,
        'consumerId':this.userdata[0].stringval1,
        'consumerMobileNo':this.userdata[0].stringval34,
        'consumerEmailId':this.userdata[0].stringval35,
        'debitStartDate':this.userdata[0].stringval32,
        'debitEndDate':this.userdata[0].stringval33,
        'maxAmount':parseFloat(this.userdata[0].stringval31).toFixed(),
        'amountType':'M',
        'frequency': 'ADHO',
        'moduleName': "OPEN_LINK_EXISTING",
        'renewalID': "OPEN_LINK_EXISTING",
        'payableAmount': 0,
        'takeAccountNo': '',
        'takeIFSCCode':'',
        'prefDate': this.userDateDetails.selectedPDate,
        'prefType':this.userDateDetails.selectedPDate ? this.userDateDetails.dateType : "",
        'authType': this.r_registerType,
       }
    }else{

    }

    // console.log(data);
    // return;
    
    let url = Constant.createCustomer;    
    let reqObj = data;
    this.spinner.show();
    this.service.PostService(url, reqObj).subscribe(response => {
      console.log(response);
      if (response && response.oid && response.custRes.id) {
        this.spinner.hide();
       this.callRozarPay(response.oid,response.custRes.id);
      }
      else {
        this.spinner.hide();
        alert(response.p_message);
      }
    })
  }

  callRozarPay(orderID,CustID) {
    let merchantID = Constant.RAZORPY_KEY;
    var options = {
        "key": merchantID,
        "order_id": orderID,
        "customer_id": CustID,
        "recurring": "1",
        "image": "./assets/img/bajaj-logo.png",
        "handler":  (response:any)=> {
            console.log(response);
            if(response){
              localStorage.setItem("s2sResponse" , JSON.stringify(response));
              this.ngZone.run(() =>this.router.navigate(['/thankYou']))
            }
        },
        "notes": {
            "note_key 1": "",
            "note_key 2": ""
        },
        "retry" :{
          "enabled" : false
      },
      "hidden": {
        "email": true,
        "contact": true
    },
        "theme": {
            "color": "#3977b7"
        }
    };
    var rzp1 = new this.service.nativeWindow.Razorpay(options);
        rzp1.open();
        rzp1.on('payment.failed',(response:any)=>{
          localStorage.setItem("razorpayError" , JSON.stringify(response));
          this.ngZone.run(() =>this.router.navigate(['/failed']))
     });
}









  sendDataForEnachExistingCust()   // ENACH FOR EXISTING CUSTOMER
  {
    if(this.desableForDwontime){
      this.modalRef1 = this.modalService.show(this.templet2, { class: 'modal-md addcompmodal' });
      event.preventDefault();
    }else{
    this.userdata.forEach(element => {
      // if (element.stringval31) {
      //   if ((element.stringval31) > 1000000) {   // mandate value or calculated value
      //     totalAmount = 1000000;  // calculated value i.e mandate value will be 10 lac
      //   } else {
      //     totalAmount = element.stringval31;
      //   }
      // } else {
      //   totalAmount = element.stringval31;
      // }
      
      var policyHolderName = element.stringval2;
      (<HTMLInputElement>document.getElementById("policyHolderNameenach")).value = '';

      var totalAmount = element.stringval31;
      (<HTMLInputElement>document.getElementById("totalAmountenach")).value = parseFloat(totalAmount).toFixed(2)

      var consumerId = element.stringval1;
      (<HTMLInputElement>document.getElementById("consumerIdenach")).value = consumerId;

      var consumerMobileNo = element.stringval34;
      (<HTMLInputElement>document.getElementById("consumerMobileNoenach")).value = consumerMobileNo;

      var consumerEmailId = element.stringval35;
      (<HTMLInputElement>document.getElementById("consumerEmailIdenach")).value = consumerEmailId;

      var debitStartDate = element.stringval32;
      (<HTMLInputElement>document.getElementById("debitStartDateenach")).value = debitStartDate;

      var debitEndDate = element.stringval33;
      (<HTMLInputElement>document.getElementById("debitEndDateenach")).value = debitEndDate;

      var maxAmount = '100';
      (<HTMLInputElement>document.getElementById("maxAmountenach")).value = maxAmount;

      var amountType = "M";
      (<HTMLInputElement>document.getElementById("amountTypeenach")).value = amountType;

      var frequency = "ADHO";
      (<HTMLInputElement>document.getElementById("frequencyenach")).value = frequency;

      var moduleName = "OPEN_LINK_EXISTING";
      (<HTMLInputElement>document.getElementById("moduleNameenach")).value = moduleName;

      (<HTMLInputElement>document.getElementById("prefdate")).value = this.userDateDetails.selectedPDate;
      (<HTMLInputElement>document.getElementById("preftype")).value = this.userDateDetails.selectedPDate ? this.userDateDetails.dateType : "";

    });
    }
    
  }


  sendDataForEnachNewCust()   // ENACH FOR NEW CUSTOMER
  {
    if(this.desableForDwontime){
      this.modalRef1 = this.modalService.show(this.templet2, { class: 'modal-md addcompmodal' });
      event.preventDefault();
    }else{
    //   var totalAmount;
    // if (this.userdata.stringval5 > 1000000) {   // calulated value
    //   totalAmount = 1000000;    // calculated value i.e mandate value will be 10 lac
    // } else {
    //   totalAmount = this.userdata.stringval5;
    // }

    // var policyHolderName = "";
    // (<HTMLInputElement>document.getElementById("policyHolderNameenach")).value = policyHolderName;

    var totalAmount = this.userdata.stringval5;
    (<HTMLInputElement>document.getElementById("totalAmountenach")).value = parseFloat(totalAmount).toFixed(2)

    var consumerId = this.userdata.stringval1;
    (<HTMLInputElement>document.getElementById("consumerIdenach")).value = consumerId;

    var consumerMobileNo = "";
    (<HTMLInputElement>document.getElementById("consumerMobileNoenach")).value = consumerMobileNo;

    var consumerEmailId = "";
    (<HTMLInputElement>document.getElementById("consumerEmailIdenach")).value = consumerEmailId;

    var debitStartDate = this.userdata.stringval3;
    (<HTMLInputElement>document.getElementById("debitStartDateenach")).value = debitStartDate;

    var debitEndDate = this.userdata.stringval4;
    (<HTMLInputElement>document.getElementById("debitEndDateenach")).value = debitEndDate;

    var maxAmount = '100';
    (<HTMLInputElement>document.getElementById("maxAmountenach")).value = maxAmount;

    var amountType = "M";
    (<HTMLInputElement>document.getElementById("amountTypeenach")).value = amountType;

    var frequency = "ADHO";
    (<HTMLInputElement>document.getElementById("frequencyenach")).value = frequency;

    // var moduleName = "INSTAB";
    // (<HTMLInputElement>document.getElementById("moduleNameenach")).value = moduleName;

    // additional for enatch

    if(this.userDateDetails.registerAccount === 'Y'){
      var takeAccountNo = this.moduleFlag?"":this.userdata.stringval8;
      (<HTMLInputElement>document.getElementById("takeAccountNoenatch")).value = takeAccountNo? takeAccountNo:"";
      var takeIFSCCode = this.moduleFlag?"":this.userdata.stringval9;
      (<HTMLInputElement>document.getElementById("takeIFSCCodeenatch")).value = takeIFSCCode?takeIFSCCode:"";
      var policyHolderName = this.moduleFlag? "":this.userdata.stringval7;
      (<HTMLInputElement>document.getElementById("policyHolderNameenach")).value = policyHolderName?policyHolderName:"";
    }else{
      (<HTMLInputElement>document.getElementById("takeAccountNoenatch")).value = "";
      (<HTMLInputElement>document.getElementById("takeIFSCCodeenatch")).value ="";
      (<HTMLInputElement>document.getElementById("policyHolderNameenach")).value = "";
    }
    }
    
  }

  sendData() {    // Mandate for new customer
  
    if(this.desableForDwontime){
      this.modalRef1 = this.modalService.show(this.templet2, { class: 'modal-md addcompmodal' });
      event.preventDefault();
    }else{
      var totalAmount = '5';
      (<HTMLInputElement>document.getElementById("totalAmount1")).value = totalAmount;
  
      var consumerId = this.userdata.stringval1;
      (<HTMLInputElement>document.getElementById("consumerId1")).value = consumerId;
  
      var consumerMobileNo = "";
      (<HTMLInputElement>document.getElementById("consumerMobileNo1")).value = consumerMobileNo;
  
      var consumerEmailId = "";
      (<HTMLInputElement>document.getElementById("consumerEmailId1")).value = consumerEmailId;
  
      var debitStartDate = this.userdata.stringval3;
      (<HTMLInputElement>document.getElementById("debitStartDate1")).value = debitStartDate;
  
      var debitEndDate = this.userdata.stringval4;
      (<HTMLInputElement>document.getElementById("debitEndDate1")).value = debitEndDate;
  
      var maxAmount = this.userdata.stringval5;
      (<HTMLInputElement>document.getElementById("maxAmount1")).value = maxAmount;
  
      var amountType = "M";
      (<HTMLInputElement>document.getElementById("amountType1")).value = 'M'
  
      var frequency = "ADHO";
      (<HTMLInputElement>document.getElementById("frequency1")).value = frequency;
  
      var renewalID = "OPEN_LINK_NEW";
      (<HTMLInputElement>document.getElementById("renewalID1")).value = renewalID;
  
      var payableAmount = '0';
      (<HTMLInputElement>document.getElementById("payableAmount1")).value = payableAmount;

      // (<HTMLInputElement>document.getElementById("encryptValue1")).value = this.encryptValue;
  
  
      // if user wnat to continue with already register no
  
      if(this.userDateDetails.registerAccount === 'Y'){
        var takeAccountNo = this.moduleFlag?"":this.userdata.stringval8;
        (<HTMLInputElement>document.getElementById("takeAccountNo1")).value = takeAccountNo? takeAccountNo:"";
        var takeIFSCCode = this.moduleFlag?"":this.userdata.stringval9;
        (<HTMLInputElement>document.getElementById("takeIFSCCode1")).value = takeIFSCCode?takeIFSCCode:"";
        var policyHolderName = this.moduleFlag?"":this.userdata.stringval7;
        (<HTMLInputElement>document.getElementById("policyHolderName1")).value = policyHolderName?policyHolderName:"";
      }else{
        (<HTMLInputElement>document.getElementById("takeAccountNo1")).value = "";
        (<HTMLInputElement>document.getElementById("takeIFSCCode1")).value ="";
        (<HTMLInputElement>document.getElementById("policyHolderName1")).value = "";
      }
  
  
    }

    // var policyHolderName = "";
    // (<HTMLInputElement>document.getElementById("policyHolderName1")).value = policyHolderName;

   

  }


  submitDataeme() {   //Emandate for Existing Customer
    if(this.desableForDwontime){
      this.modalRef1 = this.modalService.show(this.templet2, { class: 'modal-md addcompmodal' });
      event.preventDefault();
    }else{
      this.userdata.forEach(element => {

        var policyHolderName = element.stringval2;
        (<HTMLInputElement>document.getElementById("policyHolderNameexeman")).value = '';
  
        var totalAmount = '5';
        (<HTMLInputElement>document.getElementById("totalAmountexeman")).value = totalAmount;
  
        var consumerId = element.stringval1;
        (<HTMLInputElement>document.getElementById("consumerIdexeman")).value = consumerId;
  
        var consumerMobileNo = element.stringval34;
        (<HTMLInputElement>document.getElementById("consumerMobileNoexeman")).value = consumerMobileNo;
  
        var consumerEmailId = element.stringval35;
        (<HTMLInputElement>document.getElementById("consumerEmailIdexeman")).value = consumerEmailId;
  
        var debitStartDate = element.stringval32;
        (<HTMLInputElement>document.getElementById("debitStartDateexeman")).value = debitStartDate;
  
        var debitEndDate = element.stringval33;
        (<HTMLInputElement>document.getElementById("debitEndDateexeman")).value = debitEndDate;
  
        var maxAmount = element.stringval31;
        (<HTMLInputElement>document.getElementById("maxAmountexeman")).value = parseFloat(maxAmount).toFixed(2);
  
        var amountType = "M";
        (<HTMLInputElement>document.getElementById("amountTypeexeman")).value = amountType;
  
        var frequency = "ADHO";
        (<HTMLInputElement>document.getElementById("frequencyexeman")).value = frequency;
  
        var renewalID = element.stringval39;
        (<HTMLInputElement>document.getElementById("renewalIDexeman")).value = renewalID;
  
        var moduleName = "OPEN_LINK_EXISTING";
        (<HTMLInputElement>document.getElementById("moduleIdexeman")).value = moduleName;
  
        var payableAmount = '0';
        (<HTMLInputElement>document.getElementById("payableAmountexeman")).value = payableAmount;
  
        (<HTMLInputElement>document.getElementById("prefdateeman")).value = this.userDateDetails.selectedPDate;
        (<HTMLInputElement>document.getElementById("preftypeeman")).value = this.userDateDetails.selectedPDate ? this.userDateDetails.dateType : "";
      });
    }

   
  }

  sendUPIDataNewCust() {    // UPI Mandate for new customer
    if(this.desableForDwontime){
      this.modalRef1 = this.modalService.show(this.templet2, { class: 'modal-md addcompmodal' });
      event.preventDefault();
    }else{
      // if ((this.originalPremiumAmont <= 5000) && (this.userdata.stringval5 > 5000)) {   // calulated value
       var policyHolderName = "";
       (<HTMLInputElement>document.getElementById("policyHolderNameu")).value = policyHolderName;
   
       var totalAmount = '0';
       (<HTMLInputElement>document.getElementById("totalAmountu")).value = totalAmount;
   
       var consumerId = this.userdata.stringval1;
       (<HTMLInputElement>document.getElementById("consumerIdu")).value = consumerId;
   
       var consumerMobileNo = "";
       (<HTMLInputElement>document.getElementById("consumerMobileNou")).value = consumerMobileNo;
   
       var consumerEmailId = "";
       (<HTMLInputElement>document.getElementById("consumerEmailIdu")).value = consumerEmailId;
   
       var debitStartDate = this.userdata.stringval3;
       (<HTMLInputElement>document.getElementById("debitStartDateu")).value = debitStartDate;
   
       var debitEndDate = this.userdata.stringval4;
       (<HTMLInputElement>document.getElementById("debitEndDateu")).value = debitEndDate;
   
       // var maxAmount = this.userdata.stringval5;
       (<HTMLInputElement>document.getElementById("maxAmountu")).value = this.userdata.stringval5;
   
       var amountType = "M";
       (<HTMLInputElement>document.getElementById("amountTypeu")).value = 'M'
   
       var frequency = "ADHO";
       (<HTMLInputElement>document.getElementById("frequencyu")).value = frequency;
   
       var renewalID = "OPEN_LINK_NEW";
       (<HTMLInputElement>document.getElementById("renewalIDu")).value = renewalID;
   
       var payableAmount = '0';
       (<HTMLInputElement>document.getElementById("payableAmountu")).value = payableAmount;
   
    }
  }

  // upi m
  sendUPIDataInstabCust(){
    if(this.desableForDwontime){
      this.modalRef1 = this.modalService.show(this.templet2, { class: 'modal-md addcompmodal' });
      event.preventDefault();
    }else{
      if(this.userdata.stringval5 < 15000){
        var policyHolderName = "";
        (<HTMLInputElement>document.getElementById("policyHolderNamei")).value = policyHolderName;
    
        var totalAmount = '0';
        (<HTMLInputElement>document.getElementById("totalAmounti")).value = totalAmount;
    
        var consumerId = this.userdata.stringval1;
        (<HTMLInputElement>document.getElementById("consumerIdi")).value = consumerId;
    
        var consumerMobileNo = "";
        (<HTMLInputElement>document.getElementById("consumerMobileNoi")).value = consumerMobileNo;
    
        var consumerEmailId = "";
        (<HTMLInputElement>document.getElementById("consumerEmailIdi")).value = consumerEmailId;
    
        var debitStartDate = this.userdata.stringval3;
        (<HTMLInputElement>document.getElementById("debitStartDatei")).value = debitStartDate;
    
        var debitEndDate = this.userdata.stringval4;
        (<HTMLInputElement>document.getElementById("debitEndDatei")).value = debitEndDate;
    
        var maxAmount = this.userdata.stringval5;
        (<HTMLInputElement>document.getElementById("maxAmounti")).value = maxAmount;
    
        var amountType = "M";
        (<HTMLInputElement>document.getElementById("amountTypei")).value = 'M'
    
        var frequency = "ADHO";
        (<HTMLInputElement>document.getElementById("frequencyi")).value = frequency;
    
        var renewalID = "OPEN_LINK_NEW";
        (<HTMLInputElement>document.getElementById("renewalIDi")).value = renewalID;
    
        var payableAmount = '0';
        (<HTMLInputElement>document.getElementById("payableAmounti")).value = payableAmount;
    
      }
    }
  
    
  }


  sendUPIDataOldCust() {   //UPI for Existing Customer

    if(this.desableForDwontime){
      this.modalRef1 = this.modalService.show(this.templet2, { class: 'modal-md addcompmodal' });
      event.preventDefault();
    }else{
      this.userdata.forEach(element => {

        var maxAmount;
        // if (((parseInt(this.userdata[0].stringval5)) + (parseInt(this.userdata[0].stringval13))) <= 5000 && (this.userdata.stringval31 > 5000)) {   // calulated value
        //   maxAmount = 5000;    // calculated value i.e mandate value will be 10 lac
        // } else {
        //   maxAmount = this.userdata.stringval31;
        // }
  
        var policyHolderName = element.stringval2;
        (<HTMLInputElement>document.getElementById("policyHolderNameuext")).value = policyHolderName;
  
        var totalAmount = '0';
        (<HTMLInputElement>document.getElementById("totalAmountuext")).value = totalAmount;
  
        var consumerId = element.stringval1;
        (<HTMLInputElement>document.getElementById("consumerIduext")).value = consumerId;
  
        var consumerMobileNo = element.stringval34;
        (<HTMLInputElement>document.getElementById("consumerMobileNouext")).value = consumerMobileNo;
  
        var consumerEmailId = element.stringval35;
        (<HTMLInputElement>document.getElementById("consumerEmailIduext")).value = consumerEmailId;
  
        var debitStartDate = element.stringval32;
        (<HTMLInputElement>document.getElementById("debitStartDateuext")).value = debitStartDate;
  
        var debitEndDate = element.stringval33;
        (<HTMLInputElement>document.getElementById("debitEndDateuext")).value = debitEndDate;
  
        var maxAmount = element.stringval31;
        (<HTMLInputElement>document.getElementById("maxAmountuext")).value = parseFloat(maxAmount).toFixed(2);;
  
        var amountType = "M";
        (<HTMLInputElement>document.getElementById("amountTypeuext")).value = amountType;
  
        var frequency = "ADHO";
        (<HTMLInputElement>document.getElementById("frequencyuext")).value = frequency;
  
        var renewalID = element.stringval39;
        (<HTMLInputElement>document.getElementById("renewalIDuext")).value = renewalID;
  
        var moduleName = "OPEN_LINK_EXISTING";
        (<HTMLInputElement>document.getElementById("moduleIdeuext")).value = moduleName;
  
        var payableAmount = '0';
        (<HTMLInputElement>document.getElementById("payableAmountuext")).value = payableAmount;
  
        (<HTMLInputElement>document.getElementById("prefdateuext")).value = this.userDateDetails.selectedPDate;
        (<HTMLInputElement>document.getElementById("preftypeuext")).value = this.userDateDetails.selectedPDate ? this.userDateDetails.dateType : "";
  
        console.log("prefer date", this.userDateDetails)
      });
    }
   
  }


  showPopup(template) {
    this.errorMessage = 'Mandate amount exceeds maximum amount limit, please select another Autopayment mode to proceed.';
    this.modalRef = this.modalService.show(template, { class: 'modal-sm addcompmodal' });
  }

  // sendDataCredit()   // CCSI FOR New Cust
  // {
  //   if (this.userdata) {

  //     var policyHolderName = "";
  //     (<HTMLInputElement>document.getElementById("policyHolderccsinew")).value = policyHolderName;

  //     var totalAmount = this.userdata.stringval5;
  //     (<HTMLInputElement>document.getElementById("totalAmountccsinew")).value = totalAmount;

  //     var consumerId = this.userdata.stringval1;

  //     (<HTMLInputElement>document.getElementById("consumerIdccsinew")).value = consumerId;

  //     var consumerMobileNo = "";
  //     (<HTMLInputElement>document.getElementById("consumerMobileNoccsinew")).value = consumerMobileNo;

  //     var consumerEmailId = "";
  //     (<HTMLInputElement>document.getElementById("consumerEmailIdccsinew")).value = consumerEmailId;

  //     var debitStartDate = this.userdata.stringval3;
  //     (<HTMLInputElement>document.getElementById("debitStartDateccsinew")).value = debitStartDate;

  //     var debitEndDate = this.userdata.stringval4;
  //     (<HTMLInputElement>document.getElementById("debitEndDateccsinew")).value = debitEndDate;
  //     // <!-- http://10.3.4.21/CustomerPortal/policy/CCSIRegistation.do-->
  //     //https://payment.baliconline.in/BalicPayment/ccsi/payment_form.jsp
  //     // (<HTMLInputElement>document.getElementById("return_urlccsinew")).value = this.ccsiReturnUrl;
  //   }
  //   else {
  //     this.router.navigate(['/dashboard']);
  //   }
  // }

  // submitDatacreditexsting()  // CCSI for Existing Customer
  // {
  //   this.userdata.forEach(element => {
  //     var policyHolderName = element.stringval2;
  //     (<HTMLInputElement>document.getElementById("policyHolderccsiexi")).value = policyHolderName;

  //     var totalAmount = element.stringval31;
  //     (<HTMLInputElement>document.getElementById("totalAmountccsiexi")).value = totalAmount;

  //     var consumerId = element.stringval1;

  //     (<HTMLInputElement>document.getElementById("consumerIdccsiexi")).value = consumerId;

  //     var consumerMobileNo = element.stringval34;
  //     (<HTMLInputElement>document.getElementById("consumerMobileNoccsiexi")).value = consumerMobileNo;

  //     var consumerEmailId = element.stringval35;
  //     (<HTMLInputElement>document.getElementById("consumerEmailIdccsiexi")).value = consumerEmailId;

  //     var debitStartDate = element.stringval32;
  //     (<HTMLInputElement>document.getElementById("debitStartDateccsiexi")).value = debitStartDate;

  //     var debitEndDate = element.stringval33;
  //     (<HTMLInputElement>document.getElementById("debitEndDateccsiexi")).value = debitEndDate;

  //     (<HTMLInputElement>document.getElementById("return_urlccsiexi")).value = this.ccsiReturnUrl;

  //     (<HTMLInputElement>document.getElementById("prefdateccsi")).value = this.userDateDetails.selectedPDate;
  //     (<HTMLInputElement>document.getElementById("preftypeccsi")).value = this.userDateDetails.selectedPDate ? this.userDateDetails.dateType: "";
  //   });

  // }

  sendDataCredit()   // CCSI FOR New Cust
  {
    if (this.userdata) {

      var policyHolderName = "";
      (<HTMLInputElement>document.getElementById("policyHolderccsinew")).value = policyHolderName;

      var totalAmount = this.userdata.stringval5;
      (<HTMLInputElement>document.getElementById("totalAmountccsinew")).value = parseFloat(totalAmount).toFixed();

      var consumerId = this.userdata.stringval1;

      (<HTMLInputElement>document.getElementById("consumerIdccsinew")).value = consumerId;

      var consumerMobileNo = "";
      (<HTMLInputElement>document.getElementById("consumerMobileNoccsinew")).value = consumerMobileNo;

      var consumerEmailId = "";
      (<HTMLInputElement>document.getElementById("consumerEmailIdccsinew")).value = consumerEmailId;

      var debitStartDate = this.userdata.stringval3;
      (<HTMLInputElement>document.getElementById("debitStartDateccsinew")).value = debitStartDate;

      var debitEndDate = this.userdata.stringval4;
      (<HTMLInputElement>document.getElementById("debitEndDateccsinew")).value = debitEndDate;

      

      // <!-- http://10.3.4.21/CustomerPortal/policy/CCSIRegistation.do-->
      //https://payment.baliconline.in/BalicPayment/ccsi/payment_form.jsp
      // (<HTMLInputElement>document.getElementById("return_urlccsinew")).value = this.ccsiReturnUrl;
    }
    else {
      this.router.navigate(['/dashboard']);
    }
  }

  submitDatacreditexsting()  // CCSI for Existing Customer
  {
    this.userdata.forEach(element => {
      var policyHolderName = element.stringval2;
      (<HTMLInputElement>document.getElementById("policyHolderccsiexi")).value = policyHolderName;

      var totalAmount = element.stringval31;
      (<HTMLInputElement>document.getElementById("totalAmountccsiexi")).value = parseFloat(totalAmount).toFixed();

      var consumerId = element.stringval1;

      (<HTMLInputElement>document.getElementById("consumerIdccsiexi")).value = consumerId;

      var consumerMobileNo = element.stringval34;
      (<HTMLInputElement>document.getElementById("consumerMobileNoccsiexi")).value = consumerMobileNo;

      var consumerEmailId = element.stringval35;
      (<HTMLInputElement>document.getElementById("consumerEmailIdccsiexi")).value = consumerEmailId;

      var debitStartDate = element.stringval32;
      (<HTMLInputElement>document.getElementById("debitStartDateccsiexi")).value = debitStartDate;

      var debitEndDate = element.stringval33;
      (<HTMLInputElement>document.getElementById("debitEndDateccsiexi")).value = debitEndDate;

      var frequency = "ADHO";
      (<HTMLInputElement>document.getElementById("frequencyccsiexi")).value = frequency;

      // (<HTMLInputElement>document.getElementById("return_urlccsiexi")).value = this.ccsiReturnUrl;

      // (<HTMLInputElement>document.getElementById("prefdateccsi")).value = this.userDateDetails.selectedPDate;
      // (<HTMLInputElement>document.getElementById("preftypeccsi")).value = this.userDateDetails.selectedPDate ? this.userDateDetails.dateType: "";
    });

  }




//payglocal intergation starts

openCCSINRI() {
  this.spinner.show();
  let generateURL = Constant.NRIccsi;
  var options
  if (this.isstatus === 'newCustomer') {

    const date1 = this.userdata.stringval3;
    const prt = moment(date1, 'DD-MM-YYYY');
    const formattedDate1 = this.datePipe.transform(prt, 'yyyyMMdd');
    const date2 = this.userdata.stringval4;
    const prt1 = moment(date2, 'DD-MM-YYYY');
    var formattedDate2 = this.datePipe.transform(prt1, 'yyyyMMdd');

      // Calculate the year difference
    const yearDiff = moment(formattedDate2, 'YYYYMMDD').year() - moment(formattedDate1, 'YYYYMMDD').year();

    if (yearDiff > 40) {
     const maxAllowedDate = moment(formattedDate1, 'YYYYMMDD').add(40, 'years').subtract(1, 'day');
     formattedDate2 = this.datePipe.transform(maxAllowedDate, 'yyyyMMdd');
     }

    options = {
      "merchantTxnId": this.userdata.stringval1,
      "paymentType": "PGCLINTCCSI",
      "siAllowedPaymentMethods": ["CARD"],
      "allowedPaymentMethods": [
        {
          "paymentMethod": "CARD"
        }
      ],
      "paymentData": {
        "totalAmount": 1,
        "txnCurrency": "INR"
      },
      "riskData": {
        "customerData": {
          "customerCategory": "FC"
        }
      },
      "standingInstruction": {
        "data": {
          "maxAmount": parseFloat(this.userdata.stringval5).toFixed(),
          "numberOfPayments": "N",
          "frequency": "ONDEMAND",
          "type": "VARIABLE",
          "startDate": formattedDate1,
          "endDate": formattedDate2,
          "mode": "REGISTER"
        }
      },
      "merchantCallbackURL": Constant.NRIccsiCallbackURL,
      "moduleName": "OPEN_LINK_NEW",
      "policyHolderName": this.userdata.stringval7
    }
  }
  else if (this.isstatus === 'existingCustomer') {
    const date1 = this.userdata[0].stringval32;
    const prt = moment(date1, 'DD-MM-YYYY');
    const formattedDate1 = this.datePipe.transform(prt, 'yyyyMMdd');
    const date2 = this.userdata[0].stringval33;
    const prt1 = moment(date2, 'DD-MM-YYYY');
    var formattedDate2 = this.datePipe.transform(prt1, 'yyyyMMdd');

     // Calculate the year difference
     const yearDiff = moment(formattedDate2, 'YYYYMMDD').year() - moment(formattedDate1, 'YYYYMMDD').year();

     if (yearDiff > 40) {
      const maxAllowedDate = moment(formattedDate1, 'YYYYMMDD').add(40, 'years').subtract(1, 'day');
      formattedDate2 = this.datePipe.transform(maxAllowedDate, 'yyyyMMdd');
      }

    options = {
      "merchantTxnId": this.userdata[0].stringval1,
      "paymentType": "PGCLINTCCSI",
      "siAllowedPaymentMethods": ["CARD"],
      "allowedPaymentMethods": [
        {
          "paymentMethod": "CARD"
        }
      ],
      "paymentData": {
        "totalAmount": 1,
        "txnCurrency": "INR"
      },
      "riskData": {
        "customerData": {
          "customerCategory": "FC"
        }
      },
      "standingInstruction": {
        "data": {
          "maxAmount": parseFloat(this.userdata[0].stringval31).toFixed(),
          "numberOfPayments": "N",
          "frequency": "ONDEMAND",
          "type": "VARIABLE",
          "startDate": formattedDate1,
          "endDate": formattedDate2,
          "mode": "REGISTER"
        }
      },
      "merchantCallbackURL": Constant.NRIccsiCallbackURL,
      "moduleName": "OPEN_LINK_EXISTING",
      "policyHolderName": this.userdata[0].stringval2
    }

  }

  this.service.PostService(generateURL, options).subscribe((response: any) => {
    
    if (response.status == 'INPROGRESS') {
      this.ccsiPayglocal = response.data.redirectUrl;
      window.open(this.ccsiPayglocal.toString(), '_blank');
      this.spinner.hide();
    } else {
      this.toster.error("ERROR :: " + response.status);
      this.spinner.hide();
    }
  })




}

submitUPIPgcl() {
  this.spinner.show();
  let generateURL = Constant.NRIccsi;
  var options
  if (this.isstatus === 'newCustomer') {

    const date1 = this.userdata.stringval3;
    const prt = moment(date1, 'DD-MM-YYYY').toDate();
   // const prtplusoneday = moment(prt).add(1, 'day'); // add 1 day to the date
    const formattedDate1 = this.datePipe.transform(prt, 'yyyyMMdd');
    const date2 = this.userdata.stringval4;
    const prt1 = moment(date2, 'DD-MM-YYYY').toDate();
    var formattedDate2 = this.datePipe.transform(prt1, 'yyyyMMdd');


       // Calculate the year difference
       const yearDiff = moment(formattedDate2, 'YYYYMMDD').year() - moment(formattedDate1, 'YYYYMMDD').year();

       if (yearDiff > 40) {
         const maxAllowedDate = moment(formattedDate1, 'YYYYMMDD').add(40, 'years').subtract(1, 'day');
         formattedDate2 = this.datePipe.transform(maxAllowedDate, 'yyyyMMdd');
       }
    
    options = {
      "merchantTxnId": this.userdata.stringval1,
      "paymentType": "PGCLUPI",
      "siAllowedPaymentMethods": ["UPI_INTENT","UPI_COLLECT"],
      "allowedPaymentMethods": [
        {
          "paymentMethod": "UPI_INTENT"
        },
        {
          "paymentMethod": "UPI_COLLECT"
        }
      ],
      "paymentData": {
        "totalAmount": 1,
        "txnCurrency": "INR"
      },
     
      "standingInstruction": {
        "data": {
          "maxAmount": parseFloat(this.userdata.stringval5).toFixed(),
          "numberOfPayments": "N",
          "frequency": "ONDEMAND",
          "type": "VARIABLE",
          "startDate": formattedDate1,
          "endDate": formattedDate2,
          "mode": "REGISTER"
        }
      },
      "merchantCallbackURL": Constant.pgclUPICallbackURL,
      "moduleName": "OPEN_LINK_NEW",
      "policyHolderName": this.userdata.stringval7
    }

    
      
  }
  else if (this.isstatus === 'existingCustomer') {
    const date1 = this.userdata[0].stringval32;
    const prt = moment(date1, 'DD-MM-YYYY').toDate();;
    //const prtplusoneday = moment(prt).add(1, 'day'); // add 1 day to the date
    const formattedDate1 = this.datePipe.transform(prt, 'yyyyMMdd');
    const date2 = this.userdata[0].stringval33;
    const prt1 = moment(date2, 'DD-MM-YYYY').toDate();;
    var formattedDate2 = this.datePipe.transform(prt1, 'yyyyMMdd');

    
       // Calculate the year difference
   const yearDiff = moment(formattedDate2, 'YYYYMMDD').year() - moment(formattedDate1, 'YYYYMMDD').year();

   if (yearDiff > 40) {
     const maxAllowedDate = moment(formattedDate1, 'YYYYMMDD').add(40, 'years').subtract(1, 'day');
     formattedDate2 = this.datePipe.transform(maxAllowedDate, 'yyyyMMdd');
   }

    var maxAmount;
   maxAmount = this.userdata[0].stringval31;

    options = {
      "merchantTxnId": this.userdata[0].stringval1,
      "paymentType": "PGCLUPI",
      "siAllowedPaymentMethods": ["UPI_INTENT","UPI_COLLECT"],
      "allowedPaymentMethods": [
        {
          "paymentMethod": "UPI_INTENT"
        },
        {
          "paymentMethod": "UPI_COLLECT"
        }
      ],
      "paymentData": {
        "totalAmount": 1,
        "txnCurrency": "INR"
      },
      "standingInstruction": {
        "data": {
          "maxAmount": parseFloat(maxAmount).toFixed(),
          "numberOfPayments": "N",
          "frequency": "ONDEMAND",
          "type": "VARIABLE",
          "startDate": formattedDate1,
          "endDate": formattedDate2,
          "mode": "REGISTER"
        }
      },
      "merchantCallbackURL": Constant.pgclUPICallbackURL,
      "moduleName": "OPEN_LINK_EXISTING",
      "policyHolderName": this.userdata[0].stringval2
    }

  }

  this.service.PostService(generateURL, options).subscribe((response: any) => {
    if (response.status == 'INPROGRESS') {
      this.ccsiPayglocal = response.data.redirectUrl;
      window.open(this.ccsiPayglocal.toString(), '_blank');
      this.spinner.hide();
    } else {
      this.toster.error("ERROR :: " + response.status);
      this.spinner.hide();
    }
  })

}

submitNACHpgcl() {
  this.spinner.show();
  let generateURL = Constant.NRIccsi;

  var options
  if (this.isstatus === 'newCustomer') {

    const date1 = this.userdata.stringval3;
    const prt = moment(date1, 'DD-MM-YYYY').toDate();
   // const prtplusoneday = moment(prt).add(1, 'day'); // add 1 day to the date
    const formattedDate1 = this.datePipe.transform(prt, 'yyyyMMdd');
    const date2 = this.userdata.stringval4;
    const prt1 = moment(date2, 'DD-MM-YYYY').toDate();
    var formattedDate2 = this.datePipe.transform(prt1, 'yyyyMMdd');
       // Calculate the year difference
       const yearDiff = moment(formattedDate2, 'YYYYMMDD').year() - moment(formattedDate1, 'YYYYMMDD').year();
       if (yearDiff > 40) {
         const maxAllowedDate = moment(formattedDate1, 'YYYYMMDD').add(40, 'years').subtract(1, 'day');
         formattedDate2 = this.datePipe.transform(maxAllowedDate, 'yyyyMMdd');
       }

    options ={
      "merchantTxnId": this.userdata.stringval1,
      "paymentType": "PGCLNACH",
      "allowedPaymentMethods": [
      {
      "paymentMethod": "DIGITAL_BANK_MANDATE"
      }
      ],
      "siAllowedPaymentMethods": ["DIGITAL_BANK_MANDATE"],
      "paymentData": {
      "totalAmount": "1",
      "txnCurrency": "INR"
      },
      "standingInstruction" : {
      "data" : {
      "maxAmount" : parseFloat(this.userdata.stringval5).toFixed(),
      "numberOfPayments" : "N",
      "frequency" : "ONDEMAND",
      "type" : "VARIABLE",
      "startDate" : formattedDate1,
      "endDate": formattedDate2,
      "mode": "REGISTER"
      }
      },
      "moduleName": "INSTAB|OPEN_LINK_NEW",
      "product": {
      "productUserName": this.userdata.stringval7
      },
      "merchantCallbackURL": Constant.pgclNACHCallbackURL
      }
      
  }
  else if (this.isstatus === 'existingCustomer') {

    const date1 = this.userdata[0].stringval32;
    const prt = moment(date1, 'DD-MM-YYYY').toDate();;
    //const prtplusoneday = moment(prt).add(1, 'day'); // add 1 day to the date
    const formattedDate1 = this.datePipe.transform(prt, 'yyyyMMdd');
    const date2 = this.userdata[0].stringval33;
    const prt1 = moment(date2, 'DD-MM-YYYY').toDate();;
    var formattedDate2 = this.datePipe.transform(prt1, 'yyyyMMdd');

       // Calculate the year difference
       const yearDiff = moment(formattedDate2, 'YYYYMMDD').year() - moment(formattedDate1, 'YYYYMMDD').year();

       if (yearDiff > 40) {
         const maxAllowedDate = moment(formattedDate1, 'YYYYMMDD').add(40, 'years').subtract(1, 'day');
         formattedDate2 = this.datePipe.transform(maxAllowedDate, 'yyyyMMdd');
       }
    
    

    options ={
      "merchantTxnId": this.userdata[0].stringval1,
      "paymentType": "PGCLNACH",
      "allowedPaymentMethods": [
      {
      "paymentMethod": "DIGITAL_BANK_MANDATE"
      }
      ],
      "siAllowedPaymentMethods": ["DIGITAL_BANK_MANDATE"],
      "paymentData": {
      "totalAmount": "1",
      "txnCurrency": "INR",
      },
      "standingInstruction" : {
      "data" : {
      "maxAmount" :parseFloat(this.userdata[0].stringval31).toFixed(),
      "numberOfPayments" : "N",
      "frequency" : "ONDEMAND",
      "type" : "VARIABLE",
      "startDate" : formattedDate1,
      "endDate": formattedDate2,
      "mode": "REGISTER"
      }
      },
      "moduleName": "OPEN_LINK_EXISTING",
      "product": {
      "productUserName": this.userdata[0].stringval2
      },
      "merchantCallbackURL": Constant.pgclNACHCallbackURL
      }  
  }

  this.service.PostService(generateURL, options).subscribe((response: any) => {
    if (response.status == 'INPROGRESS' && response.p_next_page != 'error') {
      this.ccsiPayglocal = response.data.redirectUrl;
      window.open(this.ccsiPayglocal.toString(), '_blank');
      this.spinner.hide();
    } else if(response.status == 'INPROGRESS' && response.p_next_page == 'error'){
      this.toster.error("ERROR :" + response.p_error_msg);
      this.spinner.hide();
    }
    else {
      this.toster.error("ERROR :: " + response.status);
      this.spinner.hide();
    }
  })

}

submitCCSIpgcl() {
  this.spinner.show();
  let generateURL = Constant.NRIccsi;
  var options
  if (this.isstatus === 'newCustomer') {

    const date1 = this.userdata.stringval3;
    const prt = moment(date1, 'DD-MM-YYYY');
    const formattedDate1 = this.datePipe.transform(prt, 'yyyyMMdd');
    const date2 = this.userdata.stringval4;
    const prt1 = moment(date2, 'DD-MM-YYYY');
    var formattedDate2 = this.datePipe.transform(prt1, 'yyyyMMdd');

       // Calculate the year difference
       const yearDiff = moment(formattedDate2, 'YYYYMMDD').year() - moment(formattedDate1, 'YYYYMMDD').year();

       if (yearDiff > 40) {
         const maxAllowedDate = moment(formattedDate1, 'YYYYMMDD').add(40, 'years').subtract(1, 'day');
         formattedDate2 = this.datePipe.transform(maxAllowedDate, 'yyyyMMdd');
       }
    

    options = {
      "merchantTxnId": this.userdata.stringval1,
      "paymentType": "PGCLDOMESTICCCSI",
      "siAllowedPaymentMethods": ["CARD"],
      "allowedPaymentMethods": [
        {
          "paymentMethod": "CARD"
        }
      ],
      "paymentData": {
        "totalAmount": 1,
        "txnCurrency": "INR"
      },
      "standingInstruction": {
        "data": {
          "maxAmount": parseFloat(this.userdata.stringval5).toFixed(),
          "numberOfPayments": "N",
          "frequency": "ONDEMAND",
          "type": "VARIABLE",
          "startDate": formattedDate1,
          "endDate": formattedDate2,
          "mode": "REGISTER"
        }
      },
      "merchantCallbackURL": Constant.pgclCCSICallbackURL,
      "moduleName": "OPEN_LINK_NEW",
      "policyHolderName": ""
    }
  }
  else if (this.isstatus === 'existingCustomer') {
    const date1 = this.userdata[0].stringval32;
    const prt = moment(date1, 'DD-MM-YYYY');
    const formattedDate1 = this.datePipe.transform(prt, 'yyyyMMdd');
    const date2 = this.userdata[0].stringval33;
    const prt1 = moment(date2, 'DD-MM-YYYY');
    var formattedDate2 = this.datePipe.transform(prt1, 'yyyyMMdd');
       // Calculate the year difference
       const yearDiff = moment(formattedDate2, 'YYYYMMDD').year() - moment(formattedDate1, 'YYYYMMDD').year();

       if (yearDiff > 40) {
         const maxAllowedDate = moment(formattedDate1, 'YYYYMMDD').add(40, 'years').subtract(1, 'day');
         formattedDate2 = this.datePipe.transform(maxAllowedDate, 'yyyyMMdd');
       }
    

    options = {
      "merchantTxnId": this.userdata[0].stringval1,
      "paymentType": "PGCLDOMESTICCCSI",
      "siAllowedPaymentMethods": ["CARD"],
      "allowedPaymentMethods": [
        {
          "paymentMethod": "CARD"
        }
      ],
      "paymentData": {
        "totalAmount": 1,
        "txnCurrency": "INR"
      },
      "standingInstruction": {
        "data": {
          "maxAmount": parseFloat(this.userdata[0].stringval31).toFixed(),
          "numberOfPayments": "N",
          "frequency": "ONDEMAND",
          "type": "VARIABLE",
          "startDate": formattedDate1,
          "endDate": formattedDate2,
          "mode": "REGISTER"
        }
      },
      "merchantCallbackURL": Constant.pgclCCSICallbackURL,
      "moduleName": "OPEN_LINK_EXISTING",
      "policyHolderName": this.userdata[0].stringval2
    }

  }

  this.service.PostService(generateURL, options).subscribe((response: any) => {
    
    if (response.status == 'INPROGRESS') {
      this.ccsiPayglocal = response.data.redirectUrl;
      window.open(this.ccsiPayglocal.toString(), '_blank');
      this.spinner.hide();
    } else {
      this.toster.error("ERROR :: " + response.status);
      this.spinner.hide();
    }
  })
}

//payglocal intergation ends


//razorpay upi implementation starts
payWithRozarPayforUPI() {
  let data;
  let merchantID = Constant.RAZORPY_KEY;
  if (this.isstatus === 'newCustomer') {
    data = {
      'policyHolderName': '',
      'totalAmount': 0,
      'merchantId': merchantID,
      'consumerId': this.userdata.stringval1,
      'consumerMobileNo': '',
      'consumerEmailId': '',
      'debitStartDate': this.userdata.stringval3,
      'debitEndDate': this.userdata.stringval4,
      'maxAmount': parseFloat(this.userdata.stringval5).toFixed(),
      'amountType': 'M',
      'frequency': 'ADHO',
      'moduleName': "INSTAB|OPEN_LINK_NEW",
      // 'moduleName': "OPEN_LINK_NEW",
      'renewalID': "OPEN_LINK_NEW",
      'payableAmount': 0,
      'takeAccountNo': this.userdata.stringval8,
      'takeIFSCCode': this.userdata.stringval9,
      'prefDate': '',
      'prefType': '',
      'authType': this.r_registerType,
      "paymode": "upi"
    }

  } else if (this.isstatus === 'existingCustomer') {
    data = {
      'policyHolderName': '',
      'totalAmount': 5,
      'merchantId': merchantID,
      'consumerId': this.userdata[0].stringval1,
      'consumerMobileNo': this.userdata[0].stringval34,
      'consumerEmailId': this.userdata[0].stringval35,
      'debitStartDate': this.userdata[0].stringval32,
      'debitEndDate': this.userdata[0].stringval33,
      'maxAmount': parseFloat(this.userdata[0].stringval31).toFixed(),
      'amountType': 'M',
      'frequency': 'ADHO',
      'moduleName': "OPEN_LINK_EXISTING",
      'renewalID': "OPEN_LINK_EXISTING",
      'payableAmount': 0,
      'takeAccountNo': '',
      'takeIFSCCode': '',
      'prefDate': this.userDateDetails.selectedPDate,
      'prefType': this.userDateDetails.selectedPDate ? this.userDateDetails.dateType : "",
      'authType': this.r_registerType,
      "paymode": "upi"
    }
  } else {
  }

  let url = Constant.createCustomerUPI;
  let reqObj = data;
  this.spinner.show();
  this.service.PostService(url, reqObj).subscribe((response: any) => {
    if (response && response.oid && response.custRes.id) {
      this.spinner.hide();
      this.callRozarPayforUPI(response.oid, response.custRes.id);
    }
    else {
      this.spinner.hide();
      alert(response.p_message);
    }
  })
}

callRozarPayforUPI(orderID: any, custID: any) {
  let merchantID = Constant.RAZORPY_KEY;
  var options = {
    "key": merchantID,
    "order_id": orderID,
    "customer_id": custID,
    "recurring": "1",
    "image": "./assets/img/bajaj-logo.png",
    "handler": (response: any) => {
      console.log(response);
      if (response) {
        localStorage.setItem("s2sResponse", JSON.stringify(response));
        this.ngZone.run(() => this.router.navigate(['/rpThankYou']))
      }
    },
    "notes": {
      "note_key 1": "",
      "note_key 2": ""
    },
    "retry": {
      "enabled": false
    },
    "hidden": {
      "email": true,
      "contact": true
    },
    "theme": {
      "color": "#3977b7"
    }
  };
  var rzp1 = new this.service.nativeWindow.Razorpay(options);
  rzp1.open();
  rzp1.on('payment.failed', (response: any) => {
    localStorage.setItem("razorpayError", JSON.stringify(response));
    this.ngZone.run(() => this.router.navigate(['/rpFailed']))
  });
}

//razorpay upi implementation ends

}
